export default "__VITE_ASSET__DxGcX8df__"